import axios from "axios";
// apis/resetPassword.js
export const resetPassword = async (email) => {
  try {
    const response = await axios.post("/api/auth/password/reset/", { email });
    return response.data;
  } catch (error) {
    throw error;
  }
};
